module.exports = __webpack_public_path__ + "static/media/IMG_0331_Reduced.2996baf8.jpg";